function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from "react";
import ReactDOM from "react-dom";
import Scanner from "./scanner";
import { BrowserMultiFormatReader } from "@zxing/library/esm/browser/BrowserMultiFormatReader.js";
var styles = {
  closeButton: {
    position: "fixed",
    bottom: "0px",
    left: "0px"
  }
};

var ReactScannerField = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ReactScannerField, _Component);

  function ReactScannerField(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (codeValue) {
      console.log(codeValue);

      _this.props.onChange(codeValue);

      _this.setState({
        showScanner: false,
        value: codeValue
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleScannerClose", function () {
      _this.codeReader.stopStreams();

      _this.setState({
        showScanner: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleScannerOpen", function () {
      _this.setState({
        showScanner: true
      });
    });

    _this.codeReader = new BrowserMultiFormatReader();
    _this.state = _extends({}, props, {
      showScanner: false,
      value: null
    });
    return _this;
  }

  var _proto = ReactScannerField.prototype;

  _proto._getScanner = function _getScanner() {
    return ReactDOM.createPortal( /*#__PURE__*/React.createElement("div", {
      style: {
        position: "fixed",
        top: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(255, 255, 255, 0.5)"
      }
    }, /*#__PURE__*/React.createElement(Scanner, {
      codeReader: this.codeReader,
      codeType: "datamatrix",
      onCode: this.handleChange
    }), /*#__PURE__*/React.createElement("button", {
      style: styles.closeButton,
      onClick: this.handleScannerClose,
      className: "btn btn-block btn-secondary"
    }, "Close")), document.getElementsByTagName("body")[0]);
  };

  _proto.render = function render() {
    var _this2 = this;

    return /*#__PURE__*/React.createElement("span", null, this.state.showScanner ? this._getScanner() : /*#__PURE__*/React.createElement("span", null, this.state.value && /*#__PURE__*/React.createElement("span", {
      className: "mr-2"
    }, this.state.value), /*#__PURE__*/React.createElement("button", {
      onClick: this.handleScannerOpen,
      className: "btn btn-sm btn-secondary"
    }, "Scan"), this.state.value && /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        var clearValue = confirm("Are you sure?");
        if (clearValue) _this2.setState({
          value: null
        });
      },
      className: "btn btn-sm btn-secondary ml-1"
    }, "\xD7")));
  };

  return ReactScannerField;
}(Component);

export default ReactScannerField;